<template>
    <div :style="{'height': fieldHeight}" class="pt-3">
        <span class="px-4">Пол</span>
        <Checkbox v-model="male" label="М"/>
        <Checkbox v-model="female" label="Ж"/>
    </div>
</template>

<script>
import Checkbox from './Checkbox.vue';
export default {
    components: {
        Checkbox
    },
    props: {
        value: Boolean,
        fieldHeight: String
    },
    computed: {
        male: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        female: {
            get() {
                return !this.value;
            },
            set(val) {
                this.$emit('input', !val)
            }
        },

    },
    data: {

    }
    
}
</script>